"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redBlackTreeHeaderBeet = exports.publicKeyBeet = void 0;
const beet_1 = require("@metaplex-foundation/beet");
const beet_solana_1 = require("@metaplex-foundation/beet-solana");
/**
 * PublicKey deserializer.
 */
exports.publicKeyBeet = new beet_1.BeetArgsStruct([['publicKey', beet_solana_1.publicKey]], 'PubkeyWrapper');
/**
 * RedBlackTreeHeader deserializer.
 *
 * https://github.com/CKS-Systems/manifest/blob/main/lib/src/red_black_tree.rs
 */
exports.redBlackTreeHeaderBeet = new beet_1.BeetArgsStruct([
    ['left', beet_1.u32],
    ['right', beet_1.u32],
    ['parent', beet_1.u32],
    ['color', beet_1.u32],
], 'redBlackTreeNodeHeader');
